import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import Tasks from 'APP/Tasks';
import { OnboardingType } from 'APP/constants/onboarding';
import { Features } from 'APP/packages/features/Features';
import Entities from 'STORE';

interface IOnboardingManager {
  isNeedToShow: boolean;
  isOpened: boolean;
  init(): void;
  handleClose(): void;
}

export function useOnboardingManager(type: OnboardingType): IOnboardingManager {
  const presenter = useLocalObservable<IOnboardingManager>(() => ({
    init(): void {
      Entities.onboarding.addToShow(type);
    },

    handleClose(): void {
      Tasks.app.onboarding.closeOnboarding(type);
    },

    get isNeedToShow(): boolean {
      if (!Features.isOnboardingEnabled()) {
        return false;
      }

      return Entities.onboarding.getIsNeedToShow(type);
    },

    get isOpened(): boolean {
      return Entities.onboarding.isActiveOnboarding(type);
    },
  }));

  useEffect(() => {
    presenter.init();
  }, []);

  return presenter;
}
